import React, { PureComponent } from 'react';
import {
  BarChart, Bar, Cell, XAxis, YAxis, Tooltip,
} from 'recharts';


export default class BarGraph extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      data: [],
      key : 1
    }
  }

  componentWillReceiveProps(nextProps) {
    const oldData = this.state.data
    const newData = nextProps.data
    let changed = false
    newData.map((newDataEntry, i) => {
      if(!oldData[i] || newDataEntry["%"] != oldData[i]["%"]) changed = true
    })
    if(changed) {
      this.setState({data: nextProps.data, key: this.state.key+1})
    }
  }


  render() {
    return (
      <BarChart
        width={600}
        height={200}
        data={this.state.data}
        key={this.state.key}
      >
        <XAxis dataKey="name" />
        <YAxis />
        <Tooltip />
        <Bar dataKey="%" fill="#2f98e0" textFill="#fff" />
      </BarChart>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/user/bar.jsx